"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectedLanguageConceptMaterial = void 0;
/* eslint-disable require-jsdoc */
const constants_1 = require("../../main/constants");
const LanguageConceptMaterial_1 = require("../LanguageConceptMaterial");
class SelectedLanguageConceptMaterial extends LanguageConceptMaterial_1.LanguageConceptMaterial {
    static collectionPath() {
        throw new Error("Access SelectedLanguageConceptMaterial.collectionPath() is incorrect behavior");
    }
    static customPlanCollectionPath(customPlanId) {
        // eslint-disable-next-line max-len
        return `${constants_1.constants.COLLECTION_PATH_CUSTOM_MODULE_PLAN}/${customPlanId}/${constants_1.constants.COLLECTION_PATH_SELECTED_CONCEPT_MATERIAL}`;
    }
}
exports.SelectedLanguageConceptMaterial = SelectedLanguageConceptMaterial;
